import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_VOID } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/blank-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/blank-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/blank-extreme.guitar.json' with { type: 'json' };

export const BLANK_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'blank',
  baseTitle: "Blank",
  description: "Disfigure's Blank in three diffs — Past / Present / Future — straight from wq353qssa2's mania set. Past thins for a fair Normal feel.",
  difficulty: 4,
  palette: PALETTE_VOID,
  audioSrc: '/audio/guitar/blank.mp3',
  attribution: "\"Blank\" by Disfigure [NCS Release] - https://ncs.io/Blank",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
